import React, { useState } from 'react';
import Fade from '@material-ui/core/Fade';
import Collapse from '@material-ui/core/Collapse';

import { Flex } from 'components/layout';

import { RatingSelector } from './RatingSelector';
import {
  FeedbackWrapper,
  Form,
  SendButton,
  ThankYouMessage,
} from './styledComponents';

const Feedback = ({
  rating = null,
  comment = '',
  onSubmit,
  onRatingChange,
  onCommentChange,
}) => {
  const [showForm, setShowForm] = useState(false);

  //Controls lifecycle of the after submit message
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isFinished, setIsFinished] = useState(false);

  const handleRatingSelect = (newRating) => {
    const userIsChangingRating = rating !== null;
    onRatingChange(userIsChangingRating ? null : newRating);

    if (!showForm) {
      setShowForm(true);
    }
  };

  const handleSubmit = () => {
    onSubmit();
    setIsSubmitted(true);

    setTimeout(() => {
      setIsFinished(true);
    }, 2000);
  };

  const renderFeedback = () => (
    <FeedbackWrapper onClick={(e) => e.stopPropagation()}>
      <Collapse in={showForm} timeout={500}>
        <Form>
          <span>Additional comments?</span>
          <textarea onChange={(e) => onCommentChange(e.target.value)} />
        </Form>
      </Collapse>
      <Flex>
        <RatingSelector
          selectedRating={rating}
          onSelect={handleRatingSelect}
          showInitialMessage={!showForm}
        />
        {showForm ? (
          <SendButton disabled={!rating} onClick={handleSubmit}>
            Send
          </SendButton>
        ) : null}
      </Flex>
    </FeedbackWrapper>
  );

  return isSubmitted ? (
    <Fade in={!isFinished} timeout={1000} unmountOnExit>
      <ThankYouMessage>Thanks for your feedback!</ThankYouMessage>
    </Fade>
  ) : (
    renderFeedback()
  );
};

export { Feedback };
